/**
 * QueryClient TanStack Query — instance unique côté navigateur.
 * Branchée par <QueryClientProvider> dans main.tsx.
 */

import { QueryClient } from "@tanstack/react-query";

import { ApiException } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache 30 s → équilibre fraîcheur / coût réseau.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 4xx ne sont pas re-essayées (auth, validation, etc.).
        if (error instanceof ApiException && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
